import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import LanguageContextPrivider from "./components/contexts/LanguageContext";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <ScrollToTop />
      <LanguageContextPrivider>
        <App />
      </LanguageContextPrivider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
